import React from 'react';

import styles from './AppTitle.module.css';

export const AppTitle: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        List of laboratories
        <br />
        for corona virus testing
      </h1>
      <img
        className={styles.flag}
        src={require('../assets/images/flag_cy.svg')}
        alt='Flag of Cyprus'
      />
    </div>
  );
};
